<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">托盘号：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="托盘号"
                clearable
                v-model="queryData.PT"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-autocomplete
            style="margin-left: 20px"
            size="mini"
            popper-class="my-autocomplete"
            v-model="queryData.sampleName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入样本册"
            @select="handleSelect"
            @blur="handblur"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <span>{{ item.name }}</span>
            </template>
          </el-autocomplete>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="样本册"
            prop="sampleName"
            width="170"
            align="center"
          ></el-table-column>
          <el-table-column
            label="托盘号"
            prop="pt"
            width="140"
            align="center"
          ></el-table-column>
          <el-table-column
            label="现有数量"
            prop="current_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库数量"
            prop="instore_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库日期"
            prop="createDateStr"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库时间"
            prop="createTimeStr"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column label="操作" width="60" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-printer"
                circle
                plain
                @click.stop.prevent="printHandler(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
    <div
      id="print_area"
      style="position: relative; z-index: -1;text-align:center"
    >
      <div style="font-size:30pt">成品票</div>
      <div ref="codeItem" style="margin-top:10px"></div>
      <div style="margin-top:10px;font-size:14pt;font-weight: bold;">
        <span style="float:left;width:80px;">样本册：</span
        ><span style="float:left;width:280px;">{{
          arrayPrint.sampleName
        }}</span>
        <span style="float:left;width:100px;">托盘号：</span
        ><span style="float:left;width:220px;">{{ arrayPrint.PT }}</span>
      </div>
      <div style="margin-top:10px;font-size:12pt">
        <span style="float:left;width:115px;border:1px solid #000;">日期：</span
        ><span style="float:left;width:579px;border:1px solid #000;">{{
          arrayPrint.createDateStr
        }}</span>
      </div>
      <table
        border="1px solid #000"
        cellspacing="0"
        style="table-layout: fixed"
      >
        <tr>
          <th style="width:112px">时间</th>
          <th style="width:112px">册/箱</th>
          <th style="width:112px">箱/PT</th>
          <th style="width:112px">册数</th>
          <th style="width:112px">班长</th>
          <th style="width:112px">组长</th>
        </tr>
        <tr v-for="(item, index) in arrayPrint.instoreDetails" :key="index">
          <td>{{ item.createTimeStr }}</td>
          <td>{{ item.volumesPerCarton }}</td>
          <td>{{ item.cartons }}</td>
          <td>{{ item.volumes }}</td>
          <td>{{ item.monitorName }}</td>
          <td>{{ item.leaderName }}</td>
        </tr>
      </table>

      <div style="font-size:20pt;margin-top:10px">出库记录</div>
      <table
        border="1px solid #000"
        cellspacing="0"
        style="table-layout: fixed"
      >
        <tr>
          <th style="width:228px">时间</th>
          <th style="width:228px">出库数量</th>
          <th style="width:228px">不良品数量</th>
        </tr>
        <tr v-for="(item, index) in arrayPrint.outstoreDetails" :key="index">
          <td>{{ item.create_time }}</td>
          <td>{{ item.out_number }}</td>
          <td>{{ item.reject_number }}</td>
        </tr>
      </table>

      <div style="font-size:20pt;margin-top:10px">
        剩余数量：{{ arrayPrint.currentNumber }}
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data: function() {
    return {
      ds: [],
      queryData: {
        PT: "",
        sampleName: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      arrayPrint: {
        sampleName: "",
        PT: "",
        createDateStr: "",
        instoreDetails: [],
        outstoreDetails: [],
        currentNumber: ""
      }
    };
  },
  created: function() {},
  mounted: function() {
    this.loadProduct();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 样本册搜索
    loadProduct: function() {
      let _this = this;
      _this.get(_this.$apis.getInstoreProduct, {}, function(res) {
        _this.productList = res.data.dataList;
      });
    },
    querySearchAsync: function(queryString, cb) {
      this.product_check = "false";
      var results = queryString
        ? this.productList.filter(this.createStateFilter(queryString))
        : this.productList;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 500 * Math.random());
    },
    createStateFilter: function(queryString) {
      return product => {
        return product.name.indexOf(queryString) > -1;
      };
    },
    handleSelect: function(item) {
      let _this = this;
      _this.product_check = "true";
      _this.queryData.sampleName = item.name;
      _this.loadData();
    },
    handleIconClick: function(ev) {
      console.log(ev);
    },
    handblur: function() {
      if (this.product_check === "false") {
        this.queryData.sampleName = "";
      }
    },
    // 加载数据
    loadData: function() {
      if(this.queryData.sampleName === '') {
        this.$message.error('请选择样本册')
        return;
      }
      let _this = this;
      _this.post(
        _this.$apis.getProductPrintOutNoteList,
        this.queryData,
        function(res) {
          let _json = res.data;
          if (_json.status && _json.status === "logout") {
            _this.logout();
          } else {
            _this.ds = _json.datalist;
            _this.queryData.totalCount = _json.totalCount;
          }
        }
      );
    },
    // 打印
    printHandler: function(_row) {
      let _this = this;
      _this.$refs.codeItem.innerHTML = "";
      // 重新设计打印数据架构
      _this.arrayPrint = {
        sampleName: "",
        PT: "",
        createDateStr: "",
        instoreDetails: [],
        outstoreDetails: [],
        currentNumber: ""
      };
      _this.post(_this.$apis.printMakebookSealoutput, { PT: _row.pt,sampleName:_row.sampleName,inNumber:_row.instore_number,material_instore_detail_id:_row.id }, function(
        res
      ) {
        let _json = res.data;
        if (_json.instoreDetails.length > 0) {
          _this.arrayPrint.sampleName = _json.instoreDetails[0].sampleName;
          _this.arrayPrint.PT = _json.instoreDetails[0].pt;
          _this.arrayPrint.createDateStr =
            _json.instoreDetails[0].createDateStr;
          _this.arrayPrint.instoreDetails = _json.instoreDetails;
        }

        if (_json.outstoreDetails.length > 0) {
          _this.arrayPrint.outstoreDetails = _json.outstoreDetails;
        }

        if (_json.currentNumber !== null) {
          _this.arrayPrint.currentNumber = _json.currentNumber;
        }

        new QRCode(_this.$refs.codeItem, {
          // 二维码内容
          text:
            "PT," +
            _json.instoreDetails[0].pt +
            "," +
            _json.material_makebook_sealoutput_id +
            "," +
            _json.currentNumber +
            "," +
            _json.instoreDetails[0].sampleName,
          width: 300,
          height: 300, // 二维码颜色
          colorDark: "#333333", // 二维码背景色
          colorLight: "#ffffff"
        });
        setTimeout(() => {
          const style =
            "@page { margin-top: 50px } @media print { h1 { color: blue } img {margin: 0 auto;}}";
          _this.$print({
            printable: "print_area",
            type: "html",
            style: style,
            scanStyles: false
          });
        }, 200);
      });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.PT = "";
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    }
  },
  components: {}
};
</script>
